import type {
  InsightsOverviewResponse,
  PublishedPostDto,
} from "@nlc/shared-types";

import dayjs from "dayjs";
import { CalendarDays } from "lucide-react";

import { formatMetric } from "../formatMetric";
import { Card } from "./Card";
import { PostThumbnail } from "./PostThumbnail";

export function Highlights({
  bestPost,
  bestWeekday,
}: {
  bestPost?: PublishedPostDto;
  bestWeekday: InsightsOverviewResponse["bestWeekday"];
}) {
  return (
    <Card title="Highlights">
      {bestPost && (
        <div className="flex items-center gap-lg">
          <PostThumbnail className="size-12 rounded-md" post={bestPost} />
          <div className="flex min-w-0 flex-col">
            <span className="text-sm font-semibold text-text-primary">
              Your best post
            </span>
            <span className="truncate text-sm text-text-tertiary">
              {bestPost.name || bestPost.designs[0]?.name} ·{" "}
              {formatMetric(bestPost.insights?.views)} views
            </span>
          </div>
        </div>
      )}
      {bestWeekday && (
        <>
          <hr className="border-border-secondary" />
          <div className="flex items-center gap-lg">
            <span className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-bg-brand-primary">
              <CalendarDays className="size-5 text-fg-brand-primary" />
            </span>
            <div className="flex flex-col">
              <span className="text-sm text-text-tertiary">
                Best day to post
              </span>
              <span className="text-sm font-semibold text-text-primary">
                {dayjs().day(bestWeekday.weekday).format("dddd")}
              </span>
              <span className="text-sm text-text-tertiary">
                {formatMetric(Math.round(bestWeekday.averageViews))} views per
                post on average
              </span>
            </div>
          </div>
        </>
      )}
    </Card>
  );
}
